export default {
    buttons: {
        save: 'Sačuvaj',
    },
    fields: {
        oldPassword: {
            label: 'Lozinka',
            placeholder: 'Unesite lozinku',
        },
        email: {
            label: 'Email',
            placeholder: "john.jonhson{'@'}myemail.com",
        },
    },
    errors: {
        user_can_not_change_email_10_days_from_sign_up: 'Promijena emaila nije dostupna 10 dana od registracije',
    },
}
